module.exports = __webpack_public_path__ + "img/shop-banner.865bd18f.png";